import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {BehaviorSubject, Observable} from "rxjs";
import {map} from "rxjs/operators";
import {
  iCart, iCartTotals, iDefaultPaymentModes, iDelivery, iDeliveryModes, iPayment,
  iSupportedPaymentModes, iTowns, iSelectedSettings
} from "../model/CartModel";
import {DeliveryMode} from "../model/enums/Delivery.enum";

@Injectable({
  providedIn: 'root'
})
export class CartService {
  private cartURL = environment.links.cart.response;
  private paymentURL = environment.links.cart.paymentMode;
  private clearURL =  environment.links.cart.clear;
  private posURL = environment.links.poses.town;
  private citiesURL = environment.links.poses.towns;
  private posesAllURL = environment.links.poses.posesAll;
  private cities: Observable<string[]>;
  private cart: Observable<iDeliveryModes[]>;
  private payments  = new BehaviorSubject<string|(iDefaultPaymentModes|iSupportedPaymentModes)[]>('');
  private total = new BehaviorSubject<null|iCartTotals>(null);
  private settings = new BehaviorSubject<null|iSelectedSettings>(null);
  public paymentsModes = this.payments.asObservable();
  public cartTotal = this.total.asObservable();
  public selectedSettings = this.settings.asObservable();
  private httpOptions = {
    headers: new HttpHeaders({
      "X-CSRF-TOKEN": window['ACC']['config']['CSRFToken']
    })
  };

  constructor(private http: HttpClient) {
  }

  private requestCart() {
    return this.http.get<iCart>(this.cartURL).pipe(
      map(response => {
        this.payments.next(response.defaultPaymentModes);
        this.total.next(response.cartTotals);
        this.settings.next(response.selectedSettings);
        return response.deliveryModes;
      })
    );
  }

  private requestDelivery(_url, _code?, postPoint?) {
    const deliveryUrl = _url;
    const code = typeof _code === 'string' ? _code : '';
    const sendData = _code ? _code : '';

    return this.http.put<iDelivery>(`${deliveryUrl}${code}`, postPoint || sendData, this.httpOptions).pipe(
      map(response => {
        this.payments.next(response.supportedPaymentModes);
        this.total.next(response.cartTotals);
        this.settings.next(response.selectedSettings);
        return response;
      })
    )
  }

  private requestPayment(_payment) {
    const code = _payment;

    return this.http.put<iPayment>(`${this.paymentURL}${code}`, code, this.httpOptions).pipe(
      map(response => {
        this.total.next(response.cartTotals);
        return response;
      })
    );
  }

  private requestCities() {
    return this.http.get<iTowns>(this.citiesURL, this.httpOptions).pipe(
      map(response => {
        return response.towns;
      })
    );
  }

  private requestClear() {
    this.http.put<iDelivery>(`${this.clearURL}`, '', this.httpOptions).pipe(
      map(response => {
        this.payments.next(response.supportedPaymentModes);
        this.total.next(response.cartTotals);
        this.settings.next(response.selectedSettings);
      })
    ).subscribe();
  }

  get initCart() {
    this.cart = this.requestCart();
    return this.cart;
  }

  get initCities() {
    this.cities = this.requestCities();
    return this.cities;
  }

  getPoses(_site, _city) {
    const site = _site;
    const city = _city;
    const posURL = site === 'visionexpress' ? this.posURL : this.posesAllURL;

    return this.http.get(`${posURL}${city}`, this.httpOptions);
  }

  changeDelivery(_deliveryMode, _code?) {
    const deliveryMode = _deliveryMode.toLowerCase();
    const code = _code;
    let deliveryURL = '';

    switch(deliveryMode) {
      case DeliveryMode.dpd:
        deliveryURL = environment.links.cart.deliveryDPD;
        break;
      case DeliveryMode.dpdPickup:
        deliveryURL = environment.links.cart.deliveryDPDPickup;
        break;
      case DeliveryMode.pharmaLink:
        deliveryURL = environment.links.cart.deliveryPharmaLink;
        break;
      case DeliveryMode.email:
        deliveryURL = environment.links.cart.deliveryEmail;
        break;
      case DeliveryMode.pickup:
        deliveryURL = environment.links.cart.deliveryPickup;
        break;
      case DeliveryMode.inpost:
        deliveryURL = environment.links.cart.deliveryInpost;
        break;
      case DeliveryMode.pocztaPolskaOrlenZabka:
      case DeliveryMode.pocztaPolskaOthers:
        deliveryURL = environment.links.cart.deliveryPost;
        return this.requestDelivery(deliveryURL, deliveryMode, code)
        break;
    }
    return this.requestDelivery(deliveryURL, code);
  }

  choosePayment(_payment) {
    return this.requestPayment(_payment);
  }

  clearMethods() {
    this.requestClear();
  }
}
